import { Input } from "@/v2/components/ui/input";
import { cn } from "@/v2/lib/utils";

export interface TimePickerProps {
	id?: string;
	value: string | null;
	onChange: (value: string) => void;
	disabled?: boolean;
	className?: string;
	triggerClassName?: string;
}

function isValidTime(value: string | null | undefined): value is string {
	return /^([01]\d|2[0-3]):[0-5]\d$/.test(value ?? "");
}

export function TimePicker({
	id,
	value,
	onChange,
	disabled = false,
	className,
	triggerClassName,
}: TimePickerProps) {
	return (
		<div className={cn("flex w-full items-center", className)}>
			<Input
				id={id}
				type="time"
				value={isValidTime(value) ? value : ""}
				disabled={disabled}
				onChange={(event) => onChange(event.target.value)}
				className={cn(
					"bg-background appearance-none [&::-webkit-calendar-picker-indicator]:hidden [&::-webkit-calendar-picker-indicator]:appearance-none",
					triggerClassName,
				)}
			/>
		</div>
	);
}
